import type { ObjectId } from "@bbj-types/utils";
import type { IResolverCreateCandidateChallenge } from "@complex/Challenges/logics/types";
import { AutocompleteForm } from "@inputs/hook-form";
import { useGlobalContext } from "@root/context";
import { useMemo } from "react";
import type { Control } from "react-hook-form";
import type { IFormCreateCandidateChallenge } from "../logics";

export interface IAutocompleteChallengesProps {
  control: Control<IFormCreateCandidateChallenge, void, IResolverCreateCandidateChallenge>;
  excludeChallenges?: ObjectId[];
}

export const AutocompleteChallenges = ({ control, excludeChallenges }: IAutocompleteChallengesProps) => {
  const { challenges } = useGlobalContext();

  const options = useMemo(() => {
    if (excludeChallenges) {
      return challenges.filter((challenge) => !excludeChallenges.includes(challenge._id));
    }
    return challenges;
  }, [challenges, excludeChallenges]);

  return (
    <AutocompleteForm
      control={control}
      name="challenge"
      options={options}
      getOptionKey={(option) => option._id}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      label="Thématique *"
      size="small"
      fullWidth
    />
  );
};
